export default __webpack_public_path__ + "static/media/black-hole.01d10bda.webp";